import { render, staticRenderFns } from "./WaistShowCreateEdit.vue?vue&type=template&id=1d93fd2d&scoped=true&"
import script from "./WaistShowCreateEdit.vue?vue&type=script&lang=js&"
export * from "./WaistShowCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93fd2d",
  null
  
)

export default component.exports